/**
 * RoleChip — names the role a lockout (or a section of one) is for, at the top of the screen (Matt,
 * 2026-10-26: "Make it really clear what lockout applies to what role when they are on my screen").
 * One look, the same everywhere: the role in capitals on the firm's dark green, with a short line beside it.
 */
export default function RoleChip({ role, what }) {
  return (
    <div style={S.wrap}>
      <span style={S.role}>{role}</span>
      {what && <span style={S.what}>{what}</span>}
    </div>
  )
}

const S = {
  wrap: { display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', margin: '0 0 12px', padding: '8px 12px', borderRadius: 8, background: '#07272D', color: '#fff' },
  role: { fontFamily: '"Montserrat", sans-serif', fontSize: 11, fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: '#9fe3d6' },
  what: { fontFamily: '"DM Sans", sans-serif', fontSize: 13, color: '#fff' },
}
